module.exports = __webpack_public_path__ + "assets/img/title-411ff28b.png";